class Cookie {

    /**
     * @param {HTMLElement} element
     * @param {Object} options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._elements = {
            approve: this._element.querySelector('.cookie-bar__approve'),
            deny: this._element.querySelector('.cookie-bar__deny'),
            footer: document.querySelector('.footer')
        };

        this._elements.approve.addEventListener('click', evt =>
            this._agreeCookies(evt)
        );

        this._elements.deny.addEventListener('click', evt =>
            this._denyCookies(evt)
        );

        this._showCookieBar();

        this.MAX_HTTP_CODE = 400;
    }

    /**
     * Check whether the cookie bar should be visible. When the user already denied it, the cookie bar should vanish
     */
    _showCookieBar() {
        if (
            document.cookie
                .split(';')
                .filter(item => item.includes('userAcceptedCookies'))
                .length
        ) {
            return;
        }

        this._elements.footer.classList.add('footer--with-cookie-bar');
        this._element.removeAttribute('aria-hidden');
        this._element.classList.remove('hidden');
    }

    /**
     * When the user clicks on the 'Accept cookies' button
     */
    async _agreeCookies() {
        try {
            // eslint-disable-next-line no-magic-numbers
            const isLocal = window.location.href.indexOf('http://localhost') > -1 || window.location.href.indexOf('http://bs-local.com') > -1 || window.location.href.indexOf('spr-mpo-frontend') > -1;

            if (isLocal) {
                document.cookie = 'userAcceptedCookies=true;';
                this._hide();
                return;
            }


            const agreeTrackingCall = await fetch('/agree-tracking', {
                method: 'POST'
            });

            if (agreeTrackingCall.status >= this.MAX_HTTP_CODE) {
                throw new Error('Bad response from server');
            }

            this._hide();
        } catch (error) {
            throw new Error(error);
        }
    }

    /**
     * When the user clicks on the 'deny cookies' button
     */
    async _denyCookies() {
        try {
            // eslint-disable-next-line no-magic-numbers
            if (window.location.href.indexOf('http://localhost') > -1) {
                document.cookie = 'userAcceptedCookies=false;';
                this._hide();
                return;
            }

            const agreeTrackingCall = await fetch('/disagree-tracking', {
                method: 'POST'
            });

            if (agreeTrackingCall.status >= this.MAX_HTTP_CODE) {
                throw new Error('Bad response from server');
            }

            this._hide();
        } catch (error) {
            throw new Error(error);
        }
    }

    /**
     * Hide the cookie bar, also remove the extra padding in the footer.
     * The extra padding makes the rest of the footer visible
     */
    _hide() {
        this._element.classList.add('hidden');
        this._element.setAttribute('aria-hidden', true);
        this._elements.footer.classList.remove('footer--with-cookie-bar');
    }

    /**
     * Check if the user accepted cookies
     * @returns {boolean}
     */
    static canUseCookies() {
        if (
            document.cookie
                .split(';')
                .filter(item => item.includes('userAcceptedCookies=true'))
                .length
        ) {
            return true;
        }

        return false;
    }
}

// Exports
export default Cookie;
